import * as Redux from 'redux';

export class EditGroupAccountDialogActions {
    public static open(): (dispatch: any) => void {
        return (dispatch: any) => {
            dispatch({ type: 'Dialogs/EditGroupAccount/Open' });
        };
    }

    public static close(): (dispatch: any) => void {
        return (dispatch: any) => {
            dispatch({ type: 'Dialogs/EditGroupAccount/Close' });
        };
    }
}
